<template>
    <div>
      <div class="flex flex-col p-4 md:p-10 font-sans-serif">
        <h3 class="py-4 text-chocolate-academy-600 font-medium">
          {{ $t('timezone.title') }}
        </h3>
        <div type="text" class="mt-4 py-2 flex flex-col">
          <div class="flex flex-col md:flex-row items-center">
            <div class="text-chocolate-academy-600 mb-2 md:mb-0">
              {{ $t('timezone.local') }}
            </div>
            <div class="bg-beige-academy-100 text-chocolate-academy-600 py-1 px-4 ml-2 w-56
            border border-grey-academy-150 rounded-md">
              {{localTimezone}}
            </div>
          </div>
          <button
            v-if="choosenTimezone !== localTimezone"
            @click="saveLocalTimezone"
            class="bg-beige-academy-300 uppercase w-2/5 rounded p-2 text-white mt-5
            border border-beige-academy-300 hover:bg-white hover:text-beige-academy-300">
              {{ $t('timezone.useLocal') }}
          </button>
        </div>
        <div type="text" class="mt-4 py-2 items-center flex flex-col md:flex-row">
          <div class="text-chocolate-academy-600 mb-2 md:mb-0">
            {{ $t('timezone.default') }}
          </div>
          <div
            class="bg-beige-academy-100 text-chocolate-academy-600
             ml-2 w-56 border border-grey-academy-150 rounded-md py-1 px-4">
            {{user.timezone}}</div>
        </div>
        <div class="flex w-full md:w-1/2 justify-center md:justify-between
          mt-6" v-if="!chooseContinent">
          <button
            @click="chooseContinent=true"
            class="bg-beige-academy-300 uppercase w-2/5 rounded p-2 text-white
            border border-beige-academy-300 hover:bg-white hover:text-beige-academy-300">
            {{ $t('timezone.change') }}
          </button>
        </div>
        <div v-if="chooseContinent">
          <div class="mt-10 text-md md:text-lg flex justify-center md:justify-start">
            <custom-general-select :options="continents" v-model="selectedContinent"
              :hasOverflow="true" />
          </div>
          <div v-if="selectedContinent!==$t('timezone.area')"
            class="mt-10 text-md md:text-lg flex justify-center md:justify-start">
              <custom-general-select :options="selectedCountries" v-model="selectedTimezone"
                :isLarge="true" :hasOverflow="true" />
          </div>
          <div class="flex sm:w-1/2 justify-between"
          v-if="selectedTimezone !== 'Choose reference city'">
            <button
              @click="undo"
              class="text-beige-academy-300 uppercase rounded p-2 mt-10 w-2/5
              border-2 border-beige-academy-300 hover:bg-white">
              {{ $t('timezone.undo') }}
            </button>
            <button
              @click="saveDefaultTimezone"
              class="text-beige-academy-300 uppercase rounded p-2 mt-10 w-2/5
              border-2 border-beige-academy-300 hover:bg-white">
              {{ $t('timezone.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import ChooseTimezoneAtLogin from '@/components/modals/ChooseTimezoneAtLogin.vue';
import CustomGeneralSelect from '@/components/CustomGeneralSelect.vue';
import TimezoneMixin from '@/mixins/TimezoneMixin';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import timezones from '@/config/timezones';

export default {
  data() {
    return {
      chooseContinent: false,
      continents: [
        'Africa',
        'America',
        'Antarctica',
        'Arctic',
        'Asia',
        'Atlantic',
        'Australia',
        'Brazil',
        'Canada',
        'Europe',
        'Pacific',
        'Indian',
        'US',
      ],
      selectedContinent: this.$t('timezone.area'),
      selectedTimezone: this.$t('timezone.country'),
    };
  },

  computed: {
    ...mapGetters({
      localTimezone: 'timezone/localTimezone',
      choosenTimezone: 'timezone/choosenTimezone',
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      dashboardPath: 'auth/dashboardPath',
    }),

    selectedCountries() {
      return timezones.timezones.filter((country) => {
        const countryNames = country.split('/');
        return countryNames[0] === this.selectedContinent;
      });
    },
  },

  components: {
    CustomGeneralSelect,
  },

  mixins: [TimezoneMixin, StreamFunctionsMixin],

  methods: {
    ...mapActions({
      saveTimezone: 'auth/saveTimezone',
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),

    undo() {
      this.chooseContinent = false;
      this.selectedContinent = this.$t('timezone.area');
      this.selectedTimezone = this.$t('timezone.country');
    },

    saveLocalTimezone() {
      this.saveTimezone(this.localTimezone).then(() => {
        this.setChoosenTimezone(this.localTimezone);
        this.createNotification('success', this.$t('timezone.success'));
        this.$router.push(this.dashboardPath);
      });
    },

    saveDefaultTimezone() {
      if (this.selectedTimezone === this.$t('timezone.country')) {
        this.createNotification('error', this.$t('timezone.errorSelect'));
        return;
      }

      this.saveTimezone(this.selectedTimezone).then(() => {
        this.setChoosenTimezone(this.selectedTimezone);
        this.createNotification('success', this.$t('timezone.success'));
        this.$router.push(this.dashboardPath);
      });
    },
  },

};
</script>
